import {DatePicker} from 'antd'
import React from 'react'
import Translate from "../../../modules/local/Translate";
import {IoCalendarOutline} from "react-icons/io5";
import dayjs from "dayjs";
import {createValue} from "../utils";

export const createDateComponent =
    ({placeholder, ...props} = {}) =>
        ({name, value, onChange}) =>
            (
                <Translate>
                    {(t) => (
                        <DatePicker
                            showTime
                            name={name}
                            className="w-full"
                            format={'HH:mm - DD/MM/YYYY'}
                            suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                            placeholder={t('ex: 07:00 - 20/10/2010')}
                            value={value ? dayjs(value) : undefined}
                            onChange={(date, dateString) => {
                                onChange(
                                    createValue(
                                        name,
                                        date ? date.format() : undefined
                                    )
                                )
                            }}
                            {...props}
                        />
                    )}
                </Translate>
            )
